"use client"

import { BatteryLow } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BatteryLowIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BatteryLowIcon = component(Icon)({ as: BatteryLow })
